import { Table } from "antd"
import { TenantLastActivity } from "./tenantLastActivityModel"
import { useTenantLastActivityQuery } from "./tenantLastActivityQueries"
import moment from "moment"
import VSpace from "../../common/VSpace"
import { ColumnsType } from "antd/es/table"

const TenantLastActivityTable = () => {
    const tenantLastActivityQuery = useTenantLastActivityQuery()
    const tenantLastActivity = tenantLastActivityQuery.data ?? [] 

    const columns: ColumnsType<TenantLastActivity> = [
        {
            title: 'Tenant Name',
            dataIndex: 'tenantName',
            sorter: (a, b) => a.tenantName.localeCompare(b.tenantName),
            filters: tenantLastActivity.map(tenant => {
                return {
                    'text': tenant.tenantName,
                    'value': tenant.tenantName
                }
            }),
            filterSearch: true,
            onFilter: (value, record: TenantLastActivity) => record.tenantName.includes(value as string),
        },
        {
            title: 'Created Timestamp',
            dataIndex: 'createdTimestamp',
            render: (_, activity) => {
                return `${moment.utc(activity.createdTimestamp).local().format("MMM D YYYY h:mma")}`
              },
            sorter: (a, b) => a.createdTimestamp.localeCompare(b.createdTimestamp)
        },
        {
            title: 'Last Activity Timestamp',
            dataIndex: 'lastActivityTimestamp',
            render: (_, activity) => {
                return `${moment.utc(activity.lastActivityTimestamp).local().format("MMM D YYYY h:mma")}`
              },
            sorter: (a, b) => a.lastActivityTimestamp.localeCompare(b.lastActivityTimestamp)
        },
        {
            title: 'Days Since Last Activity',
            render: (_, activity) => {
                const today = moment(new Date())
                return `${today.diff(activity.lastActivityTimestamp, 'days')}`
              },
            sorter: (a, b) => a.lastActivityTimestamp.localeCompare(b.lastActivityTimestamp)
        },
    ]

    return <VSpace>
        <Table columns={columns} dataSource={tenantLastActivity} rowKey={x => x.tenantId} pagination={false}/>
    </VSpace>
}

export default TenantLastActivityTable